import { Component, ElementRef, Input } from "@angular/core";

import { IconService } from "app/core/services/icon.service";

import { IconName } from "app/shared/models/icon-name.type";
import { IconSize } from "app/shared/models/icon-size.type";
import { provideAngularSvgIcon, SvgIconComponent } from "angular-svg-icon";
import { NgClass } from "@angular/common";

@Component({
  selector: "app-svg-icon",
  styleUrls: ["./svg-icon.component.scss"],
  template:
    '<svg-icon [ngClass]="[size,fill]" [src]="iconPath" [attr.data-e2e]="!e2e ? null : e2e + \'--svg-icon\'" [attr.data-e2e-id]="!e2e ? null : icon"></svg-icon>',
  imports: [SvgIconComponent, NgClass],
})
export class SvgComponent {
  @Input() public icon: IconName;
  @Input() public size: IconSize = "";
  @Input() public fill: string = "button-color";
  @Input() public e2e: string;

  constructor(private iconsService: IconService) {}

  public get iconPath(): string {
    const iconPath: string = this.iconsService.getThemeIcon(this.icon);
    return `assets/icons/${iconPath}.svg`;
  }
}
